import { type BotData } from 'use-towns-client'
import { type Address } from 'viem'

import { InstallBotOnSpaceDialog } from './InstallBotOnSpaceDialog'
import { InstallBotOnUserDialog } from './InstallBotOnUserDialog'

type BaseProps = {
    isOpen: boolean
    onClose: () => void
    bot: BotData
}

type UserTargetProps = BaseProps & {
    target: 'user'
    walletAddress: Address
    onSuccess?: () => void
    isNavigating?: boolean
}

type SpaceTargetProps = BaseProps & {
    target: 'space'
}

export type InstallBotDialogProps = UserTargetProps | SpaceTargetProps

/**
 * Unified InstallBotDialog component with discriminated union props.
 *
 * @param target - 'user' for installing on user account (DM flow), 'space' for installing on a space
 *
 * For `target: 'user'`:
 * - Shows permissions step only
 * - Installs bot on user account (handles AccountModules + app install)
 * - Calls `onSuccess` after successful install
 *
 * For `target: 'space'`:
 * - Shows full 3-step flow: permissions → space selection → channel selection
 * - Navigates to space after install
 */
export function InstallBotDialog(props: InstallBotDialogProps) {
    if (props.target === 'user') {
        return (
            <InstallBotOnUserDialog
                isOpen={props.isOpen}
                bot={props.bot}
                walletAddress={props.walletAddress}
                isNavigating={props.isNavigating}
                onClose={props.onClose}
                onSuccess={props.onSuccess}
            />
        )
    }

    return <InstallBotOnSpaceDialog isOpen={props.isOpen} bot={props.bot} onClose={props.onClose} />
}
